/**
 * PrivacyPage — `/privacy`
 *
 * Public privacy policy. Required for Google Play Console's Data Safety /
 * Store Listing sections (linked from the app's Play Store page), and
 * referenced from Google/Telegram OAuth consent as the app's policy URL.
 */
import { useTranslation } from 'react-i18next'

const SECTIONS_UZ = [
  {
    title: '1. Umumiy qoidalar',
    body: [
      "Ushbu maxfiylik siyosati 5mi.uz onlayn ta'lim platformasi (\"Platforma\", \"biz\") veb-sayti (5mi.uz) va mobil ilovasidan foydalanganda foydalanuvchi (\"siz\") haqida qanday ma'lumot yig'ilishi, saqlanishi va ishlatilishini tushuntiradi.",
      "Platformadan foydalanish orqali siz ushbu siyosat shartlariga rozilik bildirasiz.",
    ],
  },
  {
    title: "2. Qanday ma'lumotlar yig'iladi",
    body: [
      "Ro'yxatdan o'tishda: to'liq ism, login (foydalanuvchi nomi), parol (shifrlangan holda saqlanadi), elektron pochta (ixtiyoriy).",
      "Ijtimoiy tarmoqlar orqali kirishda (Google, Telegram, Apple): shu xizmatlar orqali taqdim etilgan ism, profil rasmi va identifikator (ID) — faqat sizning roziligingiz bilan.",
      "Profil rasmi (avatar) — o'zingiz yuklagan yoki ijtimoiy hisobingizdan avtomatik olingan.",
      "Imtihon faoliyati: topshirilgan imtihonlar, javoblar, natijalar, urinishlar soni va vaqti.",
      "O'qituvchilarni kuzatish (follow) va uy vazifalarini bajarish holati.",
      "Texnik ma'lumotlar: qurilma turi, ilova versiyasi, IP-manzil (xavfsizlik va nosozliklarni aniqlash uchun).",
    ],
  },
  {
    title: "3. Ma'lumotlardan qanday foydalanamiz",
    body: [
      "Hisobingizni yaratish, tizimga kirishni ta'minlash va xavfsizligini saqlash uchun.",
      "Imtihonlarni topshirish, natijalarni hisoblash va statistikani ko'rsatish uchun.",
      "O'qituvchi va talaba o'rtasidagi bog'lanishni (kuzatish, uy vazifalari) ta'minlash uchun.",
      "Firibgarlik va noto'g'ri foydalanishning oldini olish uchun (masalan, ketma-ket noto'g'ri parol kiritishda vaqtinchalik bloklash).",
      "Platformani yaxshilash va texnik nosozliklarni bartaraf etish uchun.",
    ],
  },
  {
    title: '4. Uchinchi tomon xizmatlari',
    body: [
      "Google Sign-In, Telegram Login va Sign in with Apple orqali kirishda, ushbu xizmatlar o'zlarining maxfiylik siyosatiga muvofiq ishlaydi. Biz sizning roziligingiz bilan faqat asosiy profil ma'lumotlarini (ism, ID, rasm) qabul qilamiz — parolingizga hech qachon kirish huquqimiz yo'q.",
      "Ma'lumotlaringiz reklama maqsadida uchinchi shaxslarga sotilmaydi yoki ijaraga berilmaydi.",
    ],
  },
  {
    title: '5. Ma\'lumotlarni saqlash va xavfsizlik',
    body: [
      "Parollar qaytarib bo'lmas shifrlash (hashing) usulida saqlanadi — hatto bizning jamoamiz ham asl parolingizni ko'ra olmaydi.",
      "Ma'lumotlar xavfsiz serverlarda saqlanadi va ruxsatsiz kirishdan himoyalangan.",
      "Hisobingiz mavjud bo'lgan davomida ma'lumotlaringiz saqlanadi; hisobni o'chirishni so'raganingizdan so'ng ular belgilangan muddatda o'chiriladi.",
    ],
  },
  {
    title: '6. Sizning huquqlaringiz',
    body: [
      "O'z profilingizdagi ma'lumotlarni istalgan vaqtda ko'rish va tahrirlash huquqiga egasiz (Profil / Sozlamalar bo'limi orqali).",
      "Hisobingizni o'chirishni yoki ma'lumotlaringiz nusxasini olishni pastda ko'rsatilgan aloqa orqali so'rashingiz mumkin.",
      "Ijtimoiy tarmoq orqali bog'langan hisobingizni istalgan vaqtda uzishingiz (unlink) mumkin.",
    ],
  },
  {
    title: "7. Bolalar maxfiyligi",
    body: [
      "Platforma o'quvchilar va talabalar uchun mo'ljallangan bo'lib, voyaga yetmagan foydalanuvchilar ota-ona yoki maktab nazorati ostida foydalanishi tavsiya etiladi. Biz ongli ravishda ortiqcha shaxsiy ma'lumot yig'maymiz.",
    ],
  },
  {
    title: '8. Siyosatdagi o\'zgarishlar',
    body: [
      "Ushbu maxfiylik siyosati vaqti-vaqti bilan yangilanishi mumkin. Muhim o'zgarishlar haqida platforma ichida xabar beramiz.",
    ],
  },
  {
    title: '9. Aloqa',
    body: [
      "Savol yoki so'rovlar bo'yicha: support@5mi.uz",
    ],
  },
]

export default function PrivacyPage() {
  const { t } = useTranslation()

  return (
    <div className="w-full px-4 sm:px-8 py-10" style={{ maxWidth: 800, margin: '0 auto' }}>
      <h1 className="h-display" style={{ fontSize: 32, marginBottom: 6 }}>
        {t('privacy.title', 'Maxfiylik siyosati')}
      </h1>
      <p className="t-sm t-mut" style={{ marginBottom: 32 }}>
        {t('privacy.updated', "So'nggi yangilanish")}: 2026-07-12
      </p>

      <div className="flex flex-col gap-8">
        {SECTIONS_UZ.map((section) => (
          <section key={section.title}>
            <h2 className="h-display" style={{ fontSize: 18, marginBottom: 10 }}>
              {section.title}
            </h2>
            <div className="flex flex-col gap-2">
              {section.body.map((p, i) => (
                <p key={i} className="t-sm" style={{ color: 'var(--ink-2)', lineHeight: 1.6, margin: 0 }}>
                  {p}
                </p>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  )
}
